/** 
 * @module Route table
 */
define('services/routeconfig',[],function () {
    return {
        //Authentication Routes
        loginUrl: rootPath + '/token',
        logoutUrl: rootPath + '/api/account/logout',
        registerUrl: rootPath + '/api/account/register',
        removeLoginUrl: rootPath + '/api/account/removelogin',
        setPasswordUrl: rootPath + '/api/account/setpassword',
        userInfoUrl: rootPath + '/api/account/userinfo',
        forgotPassword: rootPath + '/api/account/forgotpassword',
        resetPassword: rootPath + '/api/account/resetpassword',
        deleteaccount: rootPath + '/api/account/deleteaccount',
        login: rootPath + "/login",
        AzureUserInfo: rootPath + '/api/account/AzureMiddleware',
        refreshaftoken: rootPath + "/api/account/refreshtoken",
    };
});
